import { FiscalNfe } from './../../model/fiscal/fiscalNfe';
import { FiscalNfeItens } from './../../model/fiscal/fiscalNfeItens';
import { GenericDuploService } from '../generics/genericDuplo.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AutoRegisterService, servicesRegistry } from '../generics/servicesRegistry';

@Injectable({
  providedIn: 'root'
})

@AutoRegisterService()
export class FiscalNfeService extends GenericDuploService<FiscalNfe, FiscalNfeItens> {
  constructor(http: HttpClient) {
    super(http);
    super.initResource("fiscalnfe");
  }
}

// Alias para o campo auto-referenciado fiscalNfeRef (classeNomePesq = 'FiscalNfeRef')
// returnApi('FiscalNfeRef') procura 'FiscalNfeRefService' no registry
servicesRegistry.set('FiscalNfeRefService', FiscalNfeService);
